import { IBrand, ICarImages, IMarket, IProductImagesRequestMode, ISessionData } from 'data/schema';
import { sendApiRequest } from '.';
import logger from 'utils/log';

export interface IGetImages {
  prString: ISessionData['prString'];
  brand: IBrand;
  market: IMarket;
  vinOrMarketingCode: ISessionData['vinOrMarketingCode'];
  /** 'comparison' asks the lambda for the comparison images only. Omitted keeps the full response. */
  mode?: IProductImagesRequestMode;
}

export const gmsBrands: IBrand[] = ['V', 'N'];

export const getImages = async ({
  prString,
  brand,
  market,
  vinOrMarketingCode,
  mode,
}: IGetImages): Promise<ICarImages> => {
  if (!prString && !vinOrMarketingCode) {
    return { prString, items: [] };
  }

  if (gmsBrands.includes(brand) && !vinOrMarketingCode) {
    logger.warn(`Missing vinOrMarketingCode for brand ${brand}`);
    return { prString, items: [] };
  }

  if (!gmsBrands.includes(brand) && !prString) {
    logger.warn(`Missing prString for brand ${brand}`);
    return { prString, items: [] };
  }

  try {
    let url: string;
    if (gmsBrands.includes(brand)) {
      url = `/product-images?okapiCode=${encodeURIComponent(String(vinOrMarketingCode))}&brand=${encodeURIComponent(brand)}&market=${encodeURIComponent(market)}`;
    } else {
      url = `/product-images?aveString=${encodeURIComponent(prString || '')}&brand=${encodeURIComponent(brand)}`;
    }

    if (mode) {
      url += `&mode=${encodeURIComponent(mode)}`;
    }

    const images = await sendApiRequest<ICarImages>(url);
    if (images) {
      return images;
    }
    return { prString, items: [] };
  } catch (error) {
    logger.error('Error fetching car images:', error);
    return { prString, items: [] };
  }
};

export async function getTransparentImages({
  prString,
  brand,
}: Pick<IGetImages, 'prString' | 'brand'>): Promise<ICarImages> {
  if (!prString || brand !== 'A') return { prString, items: [] };

  const images = await sendApiRequest<ICarImages>(
    `/product-images?aveString=${encodeURIComponent(prString)}&brand=A&transparent=true`
  );
  return images ?? { prString, items: [] };
}
